import { useEffect, useState } from 'react';
import type { TaskRecord } from '../../tasks-table/tasks-table.type';
import { TaskDetail } from './task-detail';
import { TaskList } from './task-list';

export type TaskSideSectionProps = {
  tasks: TaskRecord[];
  categoryTitle: string;
  onClose: () => void;
  isLoading?: boolean;
  onExpandTaskDetails?: () => void;
};

export const TaskSideSection = ({
  tasks,
  categoryTitle,
  onClose,
  isLoading = false,
  onExpandTaskDetails,
}: TaskSideSectionProps) => {
  const [selectedTask, setSelectedTask] = useState<TaskRecord | null>(null);

  useEffect(() => {
    if (tasks) {
      setSelectedTask(null);
    }
  }, [tasks]);

  const handleSelectTask = (task: TaskRecord) => {
    setSelectedTask(task);
  };

  const handleBackToList = () => {
    setSelectedTask(null);
  };

  if (selectedTask) {
    return <TaskDetail task={selectedTask} onClose={onClose} onBack={handleBackToList} />;
  }

  return (
    <TaskList
      tasks={tasks}
      title={categoryTitle}
      onSelectTask={handleSelectTask}
      onClose={onClose}
      isLoading={isLoading}
      onExpandTaskDetails={onExpandTaskDetails}
    />
  );
};
